import type {
  IssueTypeField,
  UIAllowedValue,
  UIFieldDefinition
} from '../prepareSendIssueFields';
import { type MappingDefinition } from './MappingSchemaModels';

export type UiFieldValidationError = {
  isMissingRequired: boolean;
  isInvalidValue: boolean;
  isLengthTooLong: boolean;
};

export type UIFieldInputType = React.HTMLInputTypeAttribute | 'select';

export interface JiraFieldMapper {
  id: JiraFieldMappersKeys;
  isEnum: boolean;
  canMapThisField: (jiraSchema: IssueTypeField) => boolean;
  getDisplayValue(
    fieldSchema: IssueTypeField,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    axeIssue: any,
    fieldMapping?: MappingDefinition
  ): {
    value?: string;
    uiFieldType: UIFieldInputType;
    allowedValues?: UIAllowedValue[];
  };
  convertDisplayToIntegrationValue(uiFieldDefinition: UIFieldDefinition): {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    integrationValue: any;
    error?: UiFieldValidationError;
  };
}

export enum JiraFieldMappersKeys {
  ShortText = 'jira-short-text-mapper',
  Labels = 'jira-labels-mapper',
  Number = 'jira-number-mapper',
  Url = 'jira-url-mapper',
  Date = 'jira-date-mapper',
  SingleOption = 'jira-single-option-mapper',
  MultiOptions = 'jira-multi-options-mapper'
}
